import { c as _c } from "react/compiler-runtime";
import { SectionTitle } from "../components/common/SectionTitle";
import { ExperiencesGrid } from "../components/experiences/ExperiencesGrid";
import { ExperiencesList } from "../components/experiences/ExperiencesList";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export function ExperiencesCategoryView(t0) {
  const $ = _c(13);
  const {
    experiences,
    categoryName
  } = t0;
  let t1;
  if ($[0] !== categoryName) {
    t1 = /*#__PURE__*/_jsx(SectionTitle, {
      accentPosition: "bottom",
      className: "mb-6",
      children: categoryName
    });
    $[0] = categoryName;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const t2 = experiences.length > 0 ? `${experiences.length} upplevelser` : "Inga upplevelser";
  let t3;
  if ($[2] !== t2) {
    t3 = /*#__PURE__*/_jsx("div", {
      className: "mb-8",
      children: /*#__PURE__*/_jsx("h2", {
        className: "text-lg font-medium",
        children: t2
      })
    });
    $[2] = t2;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== experiences) {
    t4 = /*#__PURE__*/_jsx("div", {
      className: "block md:hidden",
      children: /*#__PURE__*/_jsx(ExperiencesList, {
        experiences: experiences,
        count: 20
      })
    });
    $[4] = experiences;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== experiences) {
    t5 = /*#__PURE__*/_jsx("div", {
      className: "hidden md:block",
      children: /*#__PURE__*/_jsx(ExperiencesGrid, {
        experiences: experiences,
        size: "regular"
      })
    });
    $[6] = experiences;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== t1 || $[9] !== t3 || $[10] !== t4 || $[11] !== t5) {
    t6 = /*#__PURE__*/_jsx("main", {
      className: "pt-24 md:pt-28",
      children: /*#__PURE__*/_jsxs("div", {
        className: "container mx-auto px-4 sm:px-6 lg:px-8",
        children: [t1, t3, t4, t5]
      })
    });
    $[8] = t1;
    $[9] = t3;
    $[10] = t4;
    $[11] = t5;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  return t6;
}